module.exports = __webpack_public_path__ + "static/media/MEDP_0.6_4_L_L.41d5a908.png";